import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Collapse } from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalImportStock from "./ModalImportStock";
import ImportUpdateStock from "./ImportUpdateStock";
import ImportDeleteStock from "./ImportDeleteStock";

export default function ModalAllImports(props) {
  const { toggle, isOpen, idEvent, refetch, jwt } = props;
  // collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

  function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Estoques</ModalHeader>
        <ModalBody>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Criar Estoques"
              setIsOpen={toggleCollapseCreate}
              isOpen={collapseCreate}
            />
          </Row>

          <Collapse isOpen={collapseCreate}>
            <ModalImportStock jwt={jwt} toggleModal={toggle} idEvent={idEvent} refetch={refetch} />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Atualizar Estoques"
              setIsOpen={toggleCollapseUpdate}
              isOpen={collapseUpdate}
            />
          </Row>

          <Collapse isOpen={collapseUpdate}>
            <ImportUpdateStock
              toggleModal={toggle}
              idEvent={idEvent}
              refetch={refetch}
              jwt={jwt}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Deletar Estoques"
              setIsOpen={toggleCollapseDelete}
              isOpen={collapseDelete}
            />
          </Row>

          <Collapse isOpen={collapseDelete}>
            <ImportDeleteStock
              toggleModal={toggle}
              idEvent={idEvent}
              refetch={refetch}
              jwt={jwt}
            />
          </Collapse>
        </ModalBody>
      </Modal>
    </>
  );
}
